
import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    { name: 'Home', path: '/' },
    { name: 'Features', path: '/features' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms of Service', path: '/terms-of-service' }
  ];

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/0e1febb5c446844011e1a9fd921d94f7/7408ff9ce9e3df133e836a3c2cd324cd.png" 
                  alt="Prismatics AI" 
                  className="w-8 h-8 object-contain"
                />
              </div>
              <span className="text-xl font-bold text-white">Prismatics AI</span>
            </Link>
            <p className="text-gray-400 text-sm">
              Transform your data into actionable insights with our intelligent analytics platform.
            </p>
          </div>

          {/* Links */}
          <div className="col-span-1 md:col-span-2">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {footerLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Prismatics AI. All rights reserved.
          </p>
                  </div>
      </div>
    </footer>
  );
}
